/**
 * @flow
 * Created by neo on 18.07.17.
 */
import React, { Component } from 'react';
import { observer } from 'mobx-react';

const styles = {
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  innerContainer: {
    background: 'black',
    opacity: 0.4,
    color: 'white',
    padding: 64,
  },
  text: {
    color: 'white',
    opacity: 1,
    fontSize: '32px',
  }
}

type Props = {
  show: boolean
};

@observer
export default class LoadingOverlay extends Component<Props> {
  render() {
    if(this.props.show) {
      return (
        <div style={styles.container}>
          <div style={styles.innerContainer}>
            <div style={styles.text}>{'Inhalte werden geladen'}</div>
          </div>
        </div>
      );
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/App/Components/LoadingOverlay.js